export const VerificationStatus = {
    DRAFT: "draft_verification",
    INCOMPLETE: "verification_incomplete",
    PENDING: "pending_verification",
    VERIFIED: "verified",
    FAILED: "verification_failed",
    EXPIRED: "verification_expired"
}

export const VerificationStep = Object.freeze({
    Country: 0,
    Flow: 1,
    Tier: 2,
    Document: 3,
    DocumentGroup: 4,
    Form: 5,
    Status: 6,
});